import React from "react";
import OrganizationChart from "@dabeng/react-orgchart";
import Container from "./styles";
import MyNode from "./node";
import IComponentOrgChart from "./interface";

const OrgChart: React.FC<IComponentOrgChart> = ({ dataSource, zoom, pan }) => (
	<Container>
		<OrganizationChart 
			datasource={dataSource} 
			chartClass="myChart" 
			NodeTemplate={MyNode} 
			zoom={zoom} 
			pan={pan} 
			zoomoutLimit={0.25} 
		/>
	</Container>
);

export default OrgChart;
